import { render, staticRenderFns } from "./userModuleList.vue?vue&type=template&id=624aa9d0&scoped=true&"
import script from "./userModuleList.vue?vue&type=script&lang=js&"
export * from "./userModuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624aa9d0",
  null
  
)

export default component.exports